import Icon from 'veui/components/Icon'
import { IconPauseCircle } from 'dls-icons-vue'

Icon.register('pause-circle', IconPauseCircle)
